// src/components/store/sections/gallery/GalleryV27MasonrygridOceanCyan.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV27MasonrygridOceanCyan(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={27}
      archKey="masonry_grid"
      archLabel="Dynamic Masonry"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
